<template>
  <div
    v-if="message"
    :class="`days-left-message ${status}`"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'DaysLeft',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      message: null,
      status: ''
    }
  },
  mounted() {
    this.calculateDaysLeft();
  },
  methods: {
    calculateDaysLeft() {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const start = new Date(this.startDate)
      const end = new Date(this.endDate)
      const currentDate = new Date();
      // console.log('currentDate:', currentDate, ' start:', start, ' end:', end);
      if (currentDate < start) {
        const diffDays = Math.round(Math.abs((start - currentDate) / oneDay));
        this.message = diffDays > 1 ? `Challenge beginnt in ${diffDays} Tagen` : `Challege läuft noch 1 Tag`;
      }
      else if (start < currentDate && currentDate < end) {
        const diffDays = Math.round(Math.abs((start - currentDate) / oneDay));
        this.status = 'started'
        this.message = 'Challenge begonnen';
      }
      else if (end < currentDate) {
        this.status = 'finished'
        this.message = 'Challege beendet';
      }
      else {
        // shouldn't show ever
        const diffDays = Math.round(Math.abs((currentDate - start) / oneDay));
        this.message = diffDays > 1 ? `Challege läuft noch ${diffDays} Tagen` : `Challege läuft noch 1 Tag`;
      }

    }
  },
}
</script>

<style lang="scss" scoped>
.days-left-message {
  font-size: 14px;
  font-weight: 400;
  margin: 5px 1px;
  padding: 11px 10px;
  border: 1px solid black;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  &.started {
    background: black;
    color: white;
  }
  &.finished {
    background: #999999;
    border-color: #999999;
    color: white;
  }
}
</style>
